module.exports = __webpack_public_path__ + "static/media/SaintColumbkillePartnership.a24b25db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/SaintColumbkillePartnership.jpg
// module id = 672
// module chunks = 0